/** @format */

import React from "react";

function AddBtnSvg({ handleAddItem }: any) {
   return (
      <div onClick={handleAddItem}>
         <svg
            width="90"
            height="40"
            viewBox="0 0 90 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <rect
               width="90"
               height="40"
               rx="8"
               fill="#0F6656"
            />
            <path
               d="M16.6007 25L20.6255 14.08H22.4351L26.4287 25H24.6815L23.7455 22.3324H19.2839L18.3479 25H16.6007ZM19.7519 21.022H23.2775L21.5147 16.0456L19.7519 21.022ZM30.7187 25.1872C29.9699 25.1872 29.3095 25.0104 28.7375 24.6568C28.1655 24.3032 27.7183 23.8196 27.3959 23.206C27.0735 22.5924 26.9123 21.8956 26.9123 21.1156C26.9123 20.3356 27.0735 19.644 27.3959 19.0408C27.7183 18.4272 28.1655 17.9488 28.7375 17.6056C29.3199 17.252 29.9855 17.0752 30.7343 17.0752C31.3479 17.0752 31.8835 17.1948 32.3411 17.434C32.8091 17.6732 33.1731 18.0112 33.4331 18.448V13.768H35.0867V25H33.6047L33.4331 23.7988C33.1835 24.1628 32.8403 24.4852 32.4035 24.766C31.9667 25.0468 31.4051 25.1872 30.7187 25.1872ZM31.0151 23.752C31.7223 23.752 32.2995 23.5076 32.7467 23.0188C33.2043 22.53 33.4331 21.9008 33.4331 21.1312C33.4331 20.3512 33.2043 19.722 32.7467 19.2436C32.2995 18.7548 31.7223 18.5104 31.0151 18.5104C30.3079 18.5104 29.7255 18.7548 29.2679 19.2436C28.8103 19.722 28.5815 20.3512 28.5815 21.1312C28.5815 21.6408 28.6855 22.0932 28.8935 22.4884C29.1015 22.8836 29.3875 23.1956 29.7515 23.4244C30.1259 23.6428 30.5471 23.752 31.0151 23.752ZM40.3972 25.1872C39.6484 25.1872 38.988 25.0104 38.416 24.6568C37.844 24.3032 37.3968 23.8196 37.0744 23.206C36.752 22.5924 36.5908 21.8956 36.5908 21.1156C36.5908 20.3356 36.752 19.644 37.0744 19.0408C37.3968 18.4272 37.844 17.9488 38.416 17.6056C38.9984 17.252 39.664 17.0752 40.4128 17.0752C41.0264 17.0752 41.562 17.1948 42.0196 17.434C42.4876 17.6732 42.8516 18.0112 43.1116 18.448V13.768H44.7652V25H43.2832L43.1116 23.7988C42.862 24.1628 42.5188 24.4852 42.082 24.766C41.6452 25.0468 41.0836 25.1872 40.3972 25.1872ZM40.6936 23.752C41.4008 23.752 41.978 23.5076 42.4252 23.0188C42.8828 22.53 43.1116 21.9008 43.1116 21.1312C43.1116 20.3512 42.8828 19.722 42.4252 19.2436C41.978 18.7548 41.4008 18.5104 40.6936 18.5104C39.9864 18.5104 39.404 18.7548 38.9464 19.2436C38.4888 19.722 38.26 20.3512 38.26 21.1312C38.26 21.6408 38.364 22.0932 38.572 22.4884C38.78 22.8836 39.066 23.1956 39.43 23.4244C39.8044 23.6428 40.2256 23.752 40.6936 23.752Z"
               fill="white"
            />
            <path
               d="M56 20L68 20"
               stroke="white"
               stroke-width="1.5"
               stroke-linecap="round"
               stroke-linejoin="round"
            />
            <path
               d="M62 26.001L62 14.001"
               stroke="white"
               stroke-width="1.5"
               stroke-linecap="round"
               stroke-linejoin="round"
            />
         </svg>
      </div>
   );
}

export default AddBtnSvg;
